import { SelectProps } from 'antd';
import { useGetOfficesQuery } from 'gql/types';
import { ControlledSelect } from 'modules/common/components';
import React, { useMemo } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  controlled: UseControllerProps<any>;
} & SelectProps;

export default function OfficeSelect({
  controlled,
  ...selectProps
}: PropTypes) {
  const { t } = useTranslation('locations.OfficeSelect');
  const officesQuery = useGetOfficesQuery();

  const options = useMemo(
    () =>
      officesQuery.data?.getOffices.map((office) => ({
        label: office.name,
        value: office.id,
      })),
    [officesQuery.data]
  );
  return (
    <ControlledSelect
      loading={officesQuery.loading}
      placeholder={t('selectOffice')}
      controlled={controlled}
      options={options}
      {...selectProps}
    />
  );
}
